import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IToggleCell } from '@construction/modules/project-edit/projects.types';

import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { TbsSwitchComponent } from '@ngx-terabase/ui/switch';
import { TbsTooltipDirective } from '@ngx-terabase/ui/tooltip';

@Component({
  selector: 'cell-toggle',
  templateUrl: './cell-toggle.component.html',
  styleUrls: ['./cell-toggle.component.scss'],
  imports: [TbsSwitchComponent, TbsTooltipDirective, FormsModule],

  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CellToggleComponent implements ICellRendererAngularComp {
  public params: ICellRendererParams & IToggleCell;
  public isChecked = false;
  public isDisabled = false;
  public tooltip = '';

  public agInit(params: ICellRendererParams & IToggleCell): void {
    this.params = params;
    this.isChecked = this.params.isChecked;
    this.tooltip = this.params.tooltip || '';
    if (this.params.isDisabled) {
      this.isDisabled = this.params.isDisabled;
    }
  }

  public refresh(): boolean {
    return true;
  }

  public toggleCheck(value: boolean) {
    this.isChecked = value;
    this.params.change(value);
  }
}
